import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import {
  FRAUD_ALERT_TOP_PANEL_DETAIL_GS_QUERY,
  ALERT_TOP_PANEL_DETAIL_GS_QUERY,
  LANDING_FROM,
  RETURN_TO_PATH,
  LANDED_IN
} from '../constant';
import BreadCrumb from '../../../../components/BreadCrumb';
import AlertTopPanelDetails from '../../../common/AlertTopPanelDetails';
import style from './index.scss';

import { TM_FRAUD_SOURCE_STRINGS } from '../../../../util/GlobalConstant';

const PageHeader = ({ settings, alertId, alertMetaSuffix, alertMetaPrefix, isEmbedded, sourceId, }) => {
  return (
    <div className={style.navPanel}>
      <Row>
        <Col style={{ position: 'static' }}>
          {!isEmbedded && <div className={style.breadcrumb}>
            <BreadCrumb
              crumbs={[
                {
                  label: LANDING_FROM,
                  linkTo: RETURN_TO_PATH
                },
                { label: LANDED_IN }
              ]}
            />
          </div>}
          {settings && (
            <div className={!isEmbedded && style.pageContentHeader}>
              <AlertTopPanelDetails
                settings={settings}
                gsQuery={sourceId && sourceId === TM_FRAUD_SOURCE_STRINGS.FRAUDIAD ? FRAUD_ALERT_TOP_PANEL_DETAIL_GS_QUERY : ALERT_TOP_PANEL_DETAIL_GS_QUERY}
                alertId={alertId}
                showAlertStatus={isEmbedded}
                alertHeader={isEmbedded ? '\n' : "Detailed View"}
                {...{ alertMetaSuffix, alertMetaPrefix }}
              />
            </div>)}
        </Col>
      </Row>
    </div>
  );
};

PageHeader.propTypes = {
  settings: PropTypes.object,
  alertId: PropTypes.string.isRequired,
  alertMetaSuffix: PropTypes.element,
  alertMetaPrefix: PropTypes.element,
  isEmbedded: PropTypes.bool,
};

export default PageHeader;
